<template>
<div style="height: 400px;overflow-y: auto;margin: 10px;padding: 0 20px">
  <div style="height: 40px"><el-button type="primary" size="small" plain icon="el-icon-plus" @click="addBtn">新增</el-button></div>
  <el-table height="340px" size="mini" :data="healthdatatype" border highlight-current-row ref="singleTable">
    <el-table-column
      type="index"
      label="序号"
      width="70"
      align="center">
    </el-table-column>
    <el-table-column
      prop="health_key"
      label="健康类型"
      min-width="100"
      align="center">
    </el-table-column>
    <el-table-column
      prop="key_name"
      label="健康类型名称"
      min-width="100"
      align="center">
    </el-table-column>
    <el-table-column align="center" label="操作" width="100">
      <template slot-scope="scope">
        <el-button size="mini" type="danger" plain @click="delBtn(scope.row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-dialog width="500px" :title="titleName" :visible.sync="addEditShow" v-if="addEditShow" append-to-body center>
    <el-form size="small" style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
      <el-form-item label="健康类型" prop="health_key">
        <el-input v-model="addEditForm.health_key" placeholder="请输入健康类型"></el-input>
      </el-form-item>
      <el-form-item label="健康类型名称" prop="key_name">
        <el-input v-model="addEditForm.key_name" placeholder="请输入健康类型名称"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-top: 30px;height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="addEditShow = false">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {queryhealthdatatype, queryhealthdataaddtype, queryhealthdatadeltype} from '../../../api/yanglaoyuan'

export default {
  name: 'healthType',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    healthObj: {
      type: Object,
      default: null
    }
  },
  data () {
    // '/^[A-Za-z0-9_\\-]+$/ig'

    // 此处自定义校验手机号码js逻辑
    var userNameReg = /[A-Za-z_\\-]/
    var validatorShow = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入健康类型名称'))
      }
      setTimeout(() => {
        if (!userNameReg.test(value)) {
          callback(new Error('只允许输入大小写字母及下划线'))
        } else {
          callback()
        }
      }, 50)
    }
    return {
      healthdatatype: [],
      titleName: '新增健康数据类型',
      addEditShow: false,
      addEditForm: {
        id: 0,
        orgid: 0,
        health_key: 0,
        key_name: ''
      },
      addEditRules: {
        key_name: [
          {required: true, message: '请输入健康类型名称', trigger: 'blur'}
        ],
        health_key: [
          {required: true, validator: validatorShow, trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.addEditForm.orgid = this.$store.state.user.orgid
    this.getHealthTypeData()
  },
  methods: {
    getHealthTypeData () {
      queryhealthdatatype().then(res => {
        this.healthdatatype = res.data.healthdatatype
      })
    },
    addBtn () {
      this.addEditForm.health_key = ''
      this.addEditForm.key_name = ''
      this.addEditShow = true
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.addEditForm.id,
            orgid: this.addEditForm.orgid,
            health_key: this.addEditForm.health_key,
            key_name: this.addEditForm.key_name
          }
          queryhealthdataaddtype(data).then(res => {
            this.getHealthTypeData()
            this.$notify({title: '成功', message: '成功新增健康数据类型', type: 'success'})
            this.$emit('updateTable')
            this.addEditShow = false
          }).catch(() => {})
        }
      })
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除该健康数据类型【' + row.key_name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        queryhealthdatadeltype(data).then(res => {
          this.getHealthTypeData()
          this.$notify({title: '成功', message: '成功删除健康数据类型', type: 'success'})
          this.$emit('updateTable')
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/healthType.vue